import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.12.3_@opentelemetry+api@1.9.0_eslint@8.24.0_sass@1.75.0_stylelint@14.16.1_typescript@4.9.5_vite@3.2.10/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/vercel/path0/middleware/redirects.global.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.12.3_@opentelemetry+api@1.9.0_eslint@8.24.0_sass@1.75.0_stylelint@14.16.1_typescript@4.9.5_vite@3.2.10/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}